/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import { months } from 'data/month';
import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Form, Modal } from 'react-bootstrap';
import ReactDatePicker from 'react-datepicker';

const tomorrowData = day =>
  new Date(new Date().getTime() + 24 * 60 * 60 * 1000 * day);

const repeatsDataOptions = [
  {
    title: 'Never',
    text: `On ${new Date(tomorrowData(2)).getDate()} ${
      months[new Date(tomorrowData(2)).getMonth()]
    } Only`
  },
  {
    title: 'Weakly',
    text: 'Every Wednesday'
  },
  {
    title: 'Biweekly',
    text: 'Every two weeks on Wednesday'
  },
  {
    title: 'monthly',
    text: `Day ${new Date(tomorrowData(2)).getDate()} of every month`
  },
  {
    title: 'Quarterly',
    text: `Day ${new Date(tomorrowData(2)).getDate()} every 3 months`
  }
];

function WiseScheduleModal({ handleClose, show, setScheduleDate }) {
  const [date, setDate] = useState(tomorrowData(2));
  const [endDate, setEndDate] = useState();
  const [repeatsData, setRepeatsData] = useState(repeatsDataOptions[0]);

  useEffect(() => {
    if (repeatsData.title !== 'Never') {
      setEndDate(new Date(date.getTime() + 24 * 60 * 60 * 1000));
    } else {
      setEndDate();
    }
  }, [date, repeatsData]);

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <Button
      className="w-100 bg-transparent border text-800 fw-normal rounded-4 mb-3"
      ref={ref}
      onClick={e => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <Flex justifyContent="between" alignItems="center">
        {children}
        <FontAwesomeIcon icon="angle-down" />
      </Flex>
    </Button>
  ));

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="fs-1">
          Create a scheduled or recurring transfer
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="fs--1 text-900">
          Scheduling a transfer works with a Wise balance. If you don't have
          one, we'll open it for you.
        </p>

        <Form>
          <Form.Group>
            <Form.Label htmlFor="date" className="fw-normal">
              Date
            </Form.Label>
            <div className="position-relative">
              <ReactDatePicker
                id="date"
                selected={date}
                onChange={date => setDate(date)}
                dateFormat="dd MMM yyyy"
                formatWeekDay={day => day.slice(0, 3)}
                className="form-control p-3 rounded-4 mb-3"
                placeholderText="Select Date"
                minDate={tomorrowData(2)}
              />
              <FontAwesomeIcon
                icon="angle-down"
                className="date-picker-arrow-icon"
              />
            </div>
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor="repeats" className="fw-normal">
              Repeats
            </Form.Label>
            <Dropdown>
              <Dropdown.Toggle
                as={CustomToggle}
                className="w-100 text-start"
                id="repeats"
              >
                <span className="text-start">
                  <p className="mb-0 fw-medium">{repeatsData?.title}</p>
                  <p className="mb-0 fs--1">{repeatsData.text}</p>
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu className="w-100 c-dropdown">
                <Dropdown.Header className="px-4">
                  Dropdown header
                </Dropdown.Header>
                <hr />
                {repeatsDataOptions?.map((item, index) => (
                  <Dropdown.Item
                    key={index}
                    onClick={e => {
                      e.preventDefault();
                      setRepeatsData(item);
                    }}
                    as="button"
                  >
                    <div
                      className={`${
                        item.title === repeatsData.title &&
                        'bg-primary text-white'
                      } hover-bg-primary py-2 px-3 rounded-3`}
                    >
                      <p className="mb-0 fw-medium">{item.title}</p>
                      <p className="mb-0">{item.text}</p>
                    </div>
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </Form.Group>
          {repeatsData.title !== 'Never' && (
            <Form.Group>
              <Form.Label htmlFor="end_date" className="fw-normal">
                End Date
              </Form.Label>
              <div className="position-relative">
                <ReactDatePicker
                  id="end_date"
                  selected={endDate}
                  onChange={date => setEndDate(date)}
                  dateFormat="dd MMM yyyy"
                  formatWeekDay={day => day.slice(0, 3)}
                  className="form-control p-3 rounded-4 mb-3"
                  placeholderText="Select Date"
                  minDate={endDate}
                />
                <FontAwesomeIcon
                  icon="angle-down"
                  className="date-picker-arrow-icon"
                />
              </div>
            </Form.Group>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Flex direction="column" className="w-100 gap-3">
          <Button
            variant="primary"
            onClick={() => {
              handleClose();
              setScheduleDate({ date, endDate, repeatsData });
            }}
            className="rounded-5 p-2"
          >
            Confirm
          </Button>
          <Button
            variant="outline-danger"
            onClick={() => {
              handleClose();
              setScheduleDate({});
            }}
            className="rounded-5 p-2"
          >
            Remove
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal>
  );
}

export default WiseScheduleModal;
